export default {
    name: 'Séparateur',
};